import { z } from "zod";
import { passwordRules } from "./password";
import { SignupStep } from "../constants";

export type ClientSignupField = "email" | "password" | "code";

export const clientStepFields: Record<number, ClientSignupField[]> = {
  [SignupStep.EMAIL]: ["email"],
  [SignupStep.EMAIL_VERIFICATION]: ["code"],
  [SignupStep.CONFIRMATION]: ["password"],
};

export const verificationCodeLength = 6;

export const clientSignupSchema = z.object({
  // Step 1
  email: z.string().email("Email address is invalid"),

  // Step 2
  code: z
    .string()
    .length(verificationCodeLength, "Verification code is invalid"),

  // Step 3
  password: z
    .string()
    .regex(passwordRules.length.regex, passwordRules.length.message)
    .regex(
      passwordRules.alphabeticalCharacter.regex,
      passwordRules.alphabeticalCharacter.message,
    )
    .regex(
      passwordRules.numericCharacter.regex,
      passwordRules.numericCharacter.message,
    )
    .regex(
      passwordRules.specialCharacter.regex,
      passwordRules.specialCharacter.message,
    ),
});

export type ClientSignupSchema = z.infer<typeof clientSignupSchema>;
